module.exports = __webpack_public_path__ + "static/media/logocompleta_embrapii.0cd4bc80.webp";